/**
 * 작성 중 초안만 sessionStorage에 둔다(설계서 10장). 인증 정보는 저장하지 않는다.
 * 저장소를 쓸 수 없는 환경(사생활 보호 모드 등)에서도 화면은 동작해야 한다.
 */
export function loadDraft<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(`chagok:draft:${key}`);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveDraft(key: string, value: unknown) {
  try {
    sessionStorage.setItem(`chagok:draft:${key}`, JSON.stringify(value));
  } catch {
    // 저장 못 해도 입력은 계속할 수 있다.
  }
}

export function clearDraft(key: string) {
  try {
    sessionStorage.removeItem(`chagok:draft:${key}`);
  } catch {
    // 무시
  }
}
